import { CostCode, CrewMember, Scalars } from '@bechtel/types';

export interface HourEntryInput {
  id: Scalars['ID'];
  maxHours: Scalars['Float'];
  description: Scalars['String'];
  hourCode: Scalars['String'];
  hours: Scalars['Float'] | undefined | null;
  reason: { id: Scalars['ID']; name: Scalars['String']; value: Scalars['String'] } | null;
  otherCommentDescription: Scalars['String'] | null;
  roundingIncrement: Scalars['Float'];
}
export interface FormikState {
  crewEmployees: CrewMember[];
  selectedCrewEmployees: CrewMember[];
  enteredHourTypes: HourEntryInput[];
  costCode: CostCode | null;
}

export enum TimesheetReasons {
  TIMESHEET_REASON_OTHER = 'TIMESHEET_REASON_OTHER',
}

export enum HourCode {
  ST = 'ST',
  OT = 'OT',
  DT = 'DT',
}
